import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RenderStatus } from 'services/finalcut.service';
import { AppThunk } from 'store/store';

export interface SetActiveClip {
  clipId: State['fcActiveClip'];
  cell: CursorCell;
}

interface State {
  fcCell: CursorCell;
  fcActiveClip: CellClip;
  fcPlayback: boolean;
}

const initialState: State = {
  fcCell: 0,
  fcActiveClip: null,
  fcPlayback: false,
};

// T H U N K S

export const setFcPlayback =
  (payload?: boolean | undefined): AppThunk =>
  (dispatch, getState) => {
    const { fcStatus } = getState().fc__data;
    if (fcStatus !== RenderStatus.rendered) return;
    dispatch(slice.actions.setFcPlayback(payload));
  };
//

// S L I C E

export const slice = createSlice({
  name: 'fc__controls',
  initialState,
  reducers: {
    setFcActiveClip: (state, action: PayloadAction<SetActiveClip>) => {
      state.fcActiveClip = action.payload.clipId;
      state.fcCell = action.payload.cell;
    },
    setFcPlayback: (state, action: PayloadAction<boolean | undefined>) => {
      state.fcPlayback = action.payload ?? !state.fcPlayback;
    },
    resetFinalcutUi: () => {
      return initialState;
    },
  },
});

export const { setFcActiveClip, resetFinalcutUi } = slice.actions;
export default slice.reducer;
